const DELIMITER = ' | ';
class DurationTrackerImpl {
    constructor() {
        this.startTimes = {};
    }
    createKey(...args) {
        return args.join(DELIMITER);
    }
    markTransactionStart(fullArtifactId, componentId, transactionName) {
        const key = this.createKey(fullArtifactId, componentId, transactionName);
        this.startTimes[key] = Date.now();
    }
    markTransactionFinish(fullArtifactId, componentId, transactionName) {
        const key = this.createKey(fullArtifactId, componentId, transactionName);
        const finishTime = Date.now();
        const startTime = this.startTimes[key] || finishTime;
        const duration = Math.round(finishTime - startTime);
        this.startTimes[key] = 0;
        return duration;
    }
}
export const createDurationTracker = () => new DurationTrackerImpl();
//# sourceMappingURL=duration-tracker.js.map